import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./GetQuote.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api, { PUBLIC_BASE_URL } from "../Api/api";
import SuccessPopup from './../thankyoupop/thankyoupop'; // Adjust path as needed

const GetQuote = () => {
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const inputRef = useRef(null);

  useEffect(() => {
    if (!window.google) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        types: ["geocode"],
        componentRestrictions: { country: "au" }, // restrict to Australia
      }
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      console.log("Selected place:", place);
      // You can also set the selected value to a state
    });
  }, []);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    service: "House Cleaning",
    cleaning_model: "Once off",
    city: "Adelaide",
    address: "",
    suburb: "",
    post_code: "",
    state: "South Australia",
    requirements: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRadioChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      cleaning_model: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/service-booking", formData);

      setShowSuccessPopup(true);


      // ✅ WhatsApp logic — opens chat with pre-filled message
      const phoneNumber = "61406958557"; // 🔁 Replace this with your WhatsApp number (e.g., 61412345678)
      const message = encodeURIComponent(
        `New Booking From Get A Quote Form:\n
Name: ${formData.first_name} ${formData.last_name}\n
Email: ${formData.email}\n
Phone: ${formData.phone}\n
Service: ${formData.service}\n
Model: ${formData.cleaning_model}\n
City: ${formData.city}\n
Address: ${formData.address}, ${formData.suburb}, ${formData.state} - ${
          formData.post_code
        }\n
Requirements: ${formData.requirements || "None"}`
      );
      const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`;
      // window.open(whatsappLink, "_blank");

      // ✅ Reset form fields
      setFormData({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        service: "House Cleaning",
        cleaning_model: "Once off",
        city: "Adelaide",
        address: "",
        suburb: "",
        post_code: "",
        state: "South Australia",
        requirements: "",
      });
    } catch (error) {
      toast.error("Failed to submit. Please try again.");
    }
  };

  return (
    <div>
      <Header />
      <div className="quote-page d-flex justify-content-center align-items-center">
        <div className="container">
          <div className="quote-form p-4 p-md-5 rounded shadow-lg mx-auto">
            <h2
              className="text-center mb-4 fw-bold"
              style={{ color: "#001070" }}
            >
              GET FREE QUOTE
            </h2>
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Phone</label>
                  <input
                    type="tel"
                    className="form-control"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Select Services</label>
                  <select
                    className="form-select"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    required
                  >
                    {[
                      "House Cleaning",
                      "Commercial Cleaning",
                      "Gutter Cleaning",
                      "Roof Cleaning",
                      "Window Cleaning",
                      "Pressure Cleaning",
                      "Solar Cleaning",
                      "NDIS Cleaning",
                      "Carpet Steam Cleaning",
                      "Oven Cleaning",
                      "Others",
                    ].map((option) => (
                      <option key={option}>{option}</option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label d-block">Cleaning Model</label>
                  {["Once off", "Weekly", "Fortnightly", "Monthly"].map(
                    (label, index) => (
                      <div key={index} className="form-check form-check-inline">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="cleaning_model"
                          id={`model-${label}`}
                          value={label}
                          checked={formData.cleaning_model === label}
                          onChange={handleRadioChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`model-${label}`}
                        >
                          {label}
                        </label>
                      </div>
                    )
                  )}
                </div>

                <div className="mb-3 mt-5">
                  <select
                    className="form-select"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select City</option>
                    <option value="Adelaide">Adelaide</option>
                    {/* <option value="Melbourne">Melbourne</option> */}
                  </select>
                </div>

                <div className="col-md-6 mb-3  position-relative">
                  <label className="form-label">Address</label>
                  <input
                    // ref={inputRef}
                    type="text"
                    className="form-control"
                    name="address"
                    placeholder="Address"
                    value={formData.address}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Suburb</label>
                  <input
                    type="text"
                    className="form-control"
                    name="suburb"
                    value={formData.suburb}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Post Code</label>
                  <input
                    type="text"
                    className="form-control"
                    name="post_code"
                    value={formData.post_code}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">State</label>
                  <select
                    className="form-select"
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    required
                  >
                    <option>South Australia</option>
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Specific Requirements</label>
                  <textarea
                    className="form-control"
                    name="requirements"
                    value={formData.requirements}
                    onChange={handleChange}
                    rows="2"
                  ></textarea>
                </div>

                <div className="col-12 text-center">
                  <button type="submit" className="btn btn-primary px-5 mt-3">
                    Submit
                  </button>
                  <SuccessPopup 
  isVisible={showSuccessPopup}
  onClose={() => setShowSuccessPopup(false)}
  message="Thank you! Your form has been submitted successfully. We'll get back to you soon!"
/>

                  <ToastContainer position="top-right" autoClose={3000} />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GetQuote;
